import { DialogTrigger } from "@indietabletop/appkit";
import {
  MenuDialogDisclosure,
  MenuSeparator,
  MoreMenu,
} from "../ActionsMenu/ActionsMenu.tsx";
import { EditGangDialog } from "../GangFormDialog/GangFormDialog.tsx";
import { CheatModeDialog } from "./CheatModeDialog.tsx";
import { CopySharedGangDialog } from "./CopySharedGangDialog.tsx";
import { DeleteGangDialog } from "./DeleteGangDialog.tsx";
import { DuplicateGangDialog } from "./DuplicateGangDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function GangActionsMenu() {
  const { readOnly, gang } = useGangContext();
  const { mode } = gang;

  if (readOnly) {
    return (
      <MoreMenu>
        <DialogTrigger>
          <CopySharedGangDialog />
          <MenuDialogDisclosure>Copy shared gang</MenuDialogDisclosure>
        </DialogTrigger>
      </MoreMenu>
    );
  }

  return (
    <MoreMenu>
      <DialogTrigger>
        <EditGangDialog />
        <MenuDialogDisclosure>Edit</MenuDialogDisclosure>
      </DialogTrigger>

      <DialogTrigger>
        <DuplicateGangDialog />
        <MenuDialogDisclosure>Duplicate</MenuDialogDisclosure>
      </DialogTrigger>

      <DialogTrigger>
        <CheatModeDialog />
        <MenuDialogDisclosure>
          {mode.isCheatModeActive ? "Disable" : "Enable"} cheat mode
        </MenuDialogDisclosure>
      </DialogTrigger>

      <MenuSeparator />

      <DialogTrigger>
        <DeleteGangDialog />
        <MenuDialogDisclosure>Delete</MenuDialogDisclosure>
      </DialogTrigger>
    </MoreMenu>
  );
}
